import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

import { MAIN_MODAL_HIDE, createPackerComment } from '../../actions/modal';
import { api } from '../../api';


const formatDate = (isoStr) => {
  if (!isoStr) return '';
  try {
    return new Date(isoStr).toLocaleString('fr-FR', {
      day: '2-digit', month: '2-digit', year: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch (e) {
    return isoStr;
  }
};

const authorName = (detail) => {
  if (!detail) return 'Inconnu';
  const fn = (detail.first_name || '').trim();
  const ln = (detail.last_name || '').trim();
  const full = `${fn} ${ln}`.trim();
  return full || detail.email || 'Inconnu';
};


const PackerCommentModalContent = ({ modal, hide, submit }) => {
  const [comment, setComment] = useState('');
  const [history, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const isOpen = !!modal && modal.modalType === 'packer_comment';
  const userId = modal && modal.userId;
  const initialMessage = (modal && modal.initialMessage) || '';

  useEffect(() => {
    if (!isOpen || !userId) {
      setHistory([]);
      return;
    }
    // Réinitialise le textarea avec l'éventuel message pré-rempli (ex. palier
    // "2 sessions" → "point explicatif fait") à chaque ouverture du modal.
    setComment(initialMessage);
    setLoadingHistory(true);
    api.getPackerComments(userId)
      .then((data) => { setHistory(Array.isArray(data) ? data : []); })
      .catch(() => { setHistory([]); })
      .then(() => { setLoadingHistory(false); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, userId, initialMessage]);

  if (!isOpen) {
    return null;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    const trimmed = comment.trim();
    if (!trimmed) return;
    submit(modal.userId, trimmed);
    setComment('');
  };

  return (
    <Modal
      show={isOpen}
      animation={false}
      backdrop={true}
      onHide={() => { setComment(''); hide(); }}
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Commentaire sur {modal.userName || 'le préparateur'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Historique des commentaires précédents */}
        <div style={{ marginBottom: '16px' }}>
          <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>
            Historique{history.length > 0 ? ` (${history.length})` : ''}
          </h6>
          {loadingHistory ? (
            <p style={{ color: '#888', fontStyle: 'italic', margin: 0 }}>Chargement…</p>
          ) : history.length === 0 ? (
            <p style={{ color: '#888', fontStyle: 'italic', margin: 0 }}>Aucun commentaire</p>
          ) : (
            <ul style={{ maxHeight: '220px', overflowY: 'auto', listStyle: 'none', padding: 0, margin: 0, border: '1px solid #eee', borderRadius: '4px' }}>
              {history.map((c) => (
                <li key={c.id} style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>
                  <div style={{ fontSize: '0.85em', color: '#666', marginBottom: '4px' }}>
                    <strong>{authorName(c.opened_by_user_detail)}</strong>
                    {' · '}
                    {formatDate(c.created_at)}
                  </div>
                  <div style={{ whiteSpace: 'pre-wrap' }}>{c.comment}</div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Nouveau commentaire */}
        <form onSubmit={onSubmit}>
          <textarea
            autoFocus
            className="form-control"
            rows={5}
            maxLength={4096}
            placeholder="Suivi de période d'essai du préparateur de commande…"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            required
          />
          <div style={{ marginTop: '12px', textAlign: 'right' }}>
            <Button variant="default" size="sm" onClick={() => { setComment(''); hide(); }} style={{ marginRight: '8px' }}>
              Annuler
            </Button>
            <Button variant="success" size="sm" type="submit" disabled={!comment.trim()}>
              Enregistrer
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export const PackerCommentModal = connect(
  (state) => ({ modal: state.m.modal }),
  (dispatch) => ({
    hide: () => dispatch({ type: MAIN_MODAL_HIDE }),
    submit: (aboutUserId, comment) => dispatch(createPackerComment(aboutUserId, comment)),
  })
)(PackerCommentModalContent);
